<template>
	<div class="tusd-wrap wrap-bg header-scroll">
		<div class="page-title"><i class="back-btn" @click="goBack"></i>分组列表</div>
		<div class="separator"></div>
		<cube-slide class="order-scroll">
			<cube-slide-item>
				<cube-scroll>
					<div class="add-bankGroup">
						<span @click="goPage('addBankGroup')"><i ></i>添加分组</span>
					</div>

					<div class="bankgroup-list">
						<div class="bankgroup-item box-wrap" v-for="group in userBankListGroups" :key="group.Id" @click="goPage('editBankGroup', group)">
							<div class="bankgroup-item-operation">
								<div>
									<span>类型：{{group.PayType==1?'银行卡':'支付宝'}}</span>&nbsp;&nbsp;|&nbsp;&nbsp;<span>名称：{{ group.Title }}</span>
								</div>
								<div>
									&nbsp;
								</div>
								<div>
									<span>状态：{{group.IsUse==1?'启用中':'未启用'}}</span>&nbsp;&nbsp;|&nbsp;&nbsp;<span>关联数量：{{group.BankCount}}</span>
								</div>
								<div>&nbsp;</div>
								<div>
									<span>
									{{ group.ServiceTimeShow }}
								</span>
								</div>
							</div>
						</div>
					</div>


				</cube-scroll>
			</cube-slide-item>
		</cube-slide>
	</div>
</template>

<script>
export default {
	name: 'bankGroupManage',
	data() {
		return {
			payTypeName: "",
			userBankListGroups: [],
			startServiceTime: 0,
			endServiceTime: 23,
			startTimeOptions: [
				{ value: 0, text: "00:00:00 (北京时间)" },
				{ value: 1, text: "01:00:00 (北京时间)" },
				{ value: 2, text: "02:00:00 (北京时间)" },
				{ value: 3, text: "03:00:00 (北京时间)" },
				{ value: 4, text: "04:00:00 (北京时间)" },
				{ value: 5, text: "05:00:00 (北京时间)" },
				{ value: 6, text: "06:00:00 (北京时间)" },
				{ value: 7, text: "07:00:00 (北京时间)" },
				{ value: 8, text: "08:00:00 (北京时间)" },
				{ value: 9, text: "09:00:00 (北京时间)" },
				{ value: 10, text: "10:00:00 (北京时间)" },
				{ value: 11, text: "11:00:00 (北京时间)" },
				{ value: 12, text: "12:00:00 (北京时间)" },
				{ value: 13, text: "13:00:00 (北京时间)" },
				{ value: 14, text: "14:00:00 (北京时间)" },
				{ value: 15, text: "15:00:00 (北京时间)" },
				{ value: 16, text: "16:00:00 (北京时间)" },
				{ value: 17, text: "17:00:00 (北京时间)" },
				{ value: 18, text: "18:00:00 (北京时间)" },
				{ value: 19, text: "19:00:00 (北京时间)" },
				{ value: 20, text: "20:00:00 (北京时间)" },
				{ value: 21, text: "21:00:00 (北京时间)" },
				{ value: 22, text: "22:00:00 (北京时间)" },
				{ value: 23, text: "23:00:00 (北京时间)" }],
			endTimeOptions: [
				{ value: 0, text: "00:59:59 (北京时间)" },
				{ value: 1, text: "01:59:59 (北京时间)" },
				{ value: 2, text: "02:59:59 (北京时间)" },
				{ value: 3, text: "03:59:59 (北京时间)" },
				{ value: 4, text: "04:59:59 (北京时间)" },
				{ value: 5, text: "05:59:59 (北京时间)" },
				{ value: 6, text: "06:59:59 (北京时间)" },
				{ value: 7, text: "07:59:59 (北京时间)" },
				{ value: 8, text: "08:59:59 (北京时间)" },
				{ value: 9, text: "09:59:59 (北京时间)" },
				{ value: 10, text: "10:59:59 (北京时间)" },
				{ value: 11, text: "11:59:59 (北京时间)" },
				{ value: 12, text: "12:59:59 (北京时间)" },
				{ value: 13, text: "13:59:59 (北京时间)" },
				{ value: 14, text: "14:59:59 (北京时间)" },
				{ value: 15, text: "15:59:59 (北京时间)" },
				{ value: 16, text: "16:59:59 (北京时间)" },
				{ value: 17, text: "17:59:59 (北京时间)" },
				{ value: 18, text: "18:59:59 (北京时间)" },
				{ value: 19, text: "19:59:59 (北京时间)" },
				{ value: 20, text: "20:59:59 (北京时间)" },
				{ value: 21, text: "21:59:59 (北京时间)" },
				{ value: 22, text: "22:59:59 (北京时间)" },
				{ value: 23, text: "23:59:59 (北京时间)" }],
		};
	},
	methods: {
		goBack() {
			this.$router.push({ name: this.params.back });
		},
		getUserBankGroups() {
			this.$api.getUserBankGroups().then((res) => {
				this.userBankListGroups = res.data
			})
		},
		goPage(name, act) {
			let params = {
				name: name,
				back: 'bankGroupManage'
			}
			if (act) {
				params = Object.assign(params, {
					groupId: act.Id
				})
			}
			console.log("params=",params)
			this.$store.commit('storeParams', params)
			this.$router.push({ name: name })

		}

	},
	created() {
		this.params = this.$store.state.routerStore.bankGroupManage;
		if (!this.params.back) {
			this.params.back = 'accounts';
		}
		this.getUserBankGroups();
	}
};
</script>
<style lang="less" scoped>
.bankgroup-list {
	padding: 14px @space;

	.bankgroup-item {
		display: flex;
		justify-content: space-between;
		padding: 18px 14px;
		color: #fff;
		margin-bottom: 10px;

		.bankgroup-item-operation {
			line-height: 15px;
			/* 确保容器有足够的宽度 */
			width: 100%;
			/* 或其他具体宽度 */
			/* 清除浮动影响（可选，取决于后续布局） */
			//overflow: auto;
		}

	}
}
.add-bankGroup{
	margin-top: 25px;
	text-align: center;
	color: #569eff;
	line-height: 28px;
	span {
		// font-size: 17px !important;
		// background-color: #3c4468;
    	// border: 1px solid #3e4771;
    	// border-radius: 7px;
    	font-size: 17px !important;
	}
	i {
		display: inline-block;
		vertical-align: middle;
		width: 28px;
		height: 28px;
		margin-right: 8px;
		background: url(../assets/images/add.svg) center center no-repeat;
	}
}
</style>
